import { registerSidebar } from "../components/ads";
import { registerDropdowns } from "../components/dropdown";
import { resizeImages } from "../components/images";
import { registerLogin, registerRegister } from "../components/login";
import { registerSharing } from "../components/share";
import { registerThemeHandler } from "../components/themes";
import { pauseVideos, registerVideos } from "../components/videos";
import { registerVoting } from "../components/vote";
import { onReady } from "../utils/page-lifecycle";
import { trackEvent } from "../utils/track";

onReady(() => {
  resizeImages();

  registerVideos();

  registerLogin();

  registerRegister();

  registerVoting();

  registerThemeHandler();

  registerSharing();

  registerDropdowns();

  registerSidebar();
  window.addEventListener("resize", resizeImages);

  document.addEventListener("scroll", handleScroll);

  trackEvent({ path: window.location.pathname });
});

function handleScroll() {
  pauseVideos();
}
